import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import ContactForm from "../../components/Contacts/ContactForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";

const ContactsCreate = ({classes, contactType, formUrl, preselectedHouse, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('contacts.new_' + contactType)}
        />

        <Paper>
            <CardContent>
                <ContactForm
                    contactType={contactType}
                    formUrl={formUrl}
                    values={preselectedHouse}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default ContactsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/contacts/Create.jsx